import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ToastType = 'success' | 'dangerous' | '';

export interface ToastState {
  show: boolean;
  message: string;
  type: ToastType;
}

const initialState: ToastState = {
  show: false,
  message: '',
  type: '',
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (
      state,
      action: PayloadAction<{ message: string; type: ToastType }>,
    ) => {
      const params = action.payload;

      state.message = params.message;
      state.type = params.type;
      state.show = true;
    },
    closeToast: (state) => {
      state.message = initialState.message;
      state.type = initialState.type;
      state.show = false;
    },
  },
});

export const { showToast, closeToast } = toastSlice.actions;
export const toastReducer = toastSlice.reducer;
